import React, { memo } from "react";
import Text from "./textElem";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default memo(
  ({
    data,
    getText,
    isStreaming,
  }: {
    data: IMultiElementCombineMsg.IDoubleTextElem;
    getText: (text: IMultiElementCombineMsg.IText) => string;
    isStreaming: boolean;
  }) => {
    const { left_content, right_content, left_width } = data;

    // 检查 left_width 是否存在且是 1-9 的整数，否则使用默认值 5
    const validLeftWidth =
      typeof left_width === "number" &&
      Number.isInteger(left_width) &&
      left_width >= 1 &&
      left_width <= 9
        ? left_width
        : 5;

    const left_width_percent = validLeftWidth / 10;
    const right_width_percent = 1 - left_width_percent;

    const style = getDefaultComponentStyle(data);

    const getSlideText = (side: string) => {
      const isLeft = side === "left";
      const widthPercent =
        side === "left" ? left_width_percent : right_width_percent;
      return (
        <div
          className={isLeft ? "leftBox" : "rightBox"}
          style={{ width: `${widthPercent * 100}%` }}
        >
          <Text
            data={{ content: isLeft ? left_content : right_content }}
            getText={getText}
            isStreaming={isStreaming}
          />
        </div>
      );
    };

    return (
      <div className={`sscard-doubleTextBox`} style={style}>
        {left_content && getSlideText("left")}
        {right_content && getSlideText("right")}
      </div>
    );
  }
);
